module.exports = __webpack_public_path__ + "img/mug-tea-saucer.62b6951d.svg";